module.exports = __webpack_public_path__ + "static/photo14-5da9a162908cf7762ffd4416f0a24737.png";